import React, { useState, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import "./data/test.css";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Swal from "sweetalert2";
// Images
import masterCardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";
import { LanguageContext } from "App";
// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

import CreateFacilityTypeReq1 from "Classes/Models/Requests/Administration/CreateFacilityTypeReq";
import MDInput from "components/MDInput";
import FacilitiesApi from "Classes/API/Administration/FacilitiesApi";

const CreateFacilityTypes = ({ setCreatedNewType }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { translations } = useContext(LanguageContext);
  const [TypeName, setTypeName] = useState("");
  const [Description, setDescription] = useState("");
  const [Category, setCategory] = useState("");
  const [ErrorText, setErrorText] = useState(false);
  const [SuccessText, setSuccessText] = useState("");

  const onSubmit = async () => {
    if (!TypeName || !Description || !Category) {
      if (!TypeName) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterName,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      if (!Description) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterDescription,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      if (!Category) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterCategory,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      setErrorText(true);
      return;
    }
    let CreateFacilityTypeReq = new CreateFacilityTypeReq1();

    CreateFacilityTypeReq.TypeName = TypeName;
    CreateFacilityTypeReq.Description = Description;
    CreateFacilityTypeReq.Category = Category;

    var res = await FacilitiesApi.CreateFacilityType(CreateFacilityTypeReq);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");
      setCreatedNewType(true);
      document.getElementById("CreateFacilityTypeForm").reset();
    } else {
      Swal.fire("Failed", res.message, "error");
    }
    console.log("Working");
  };
  return (
    <Card id="CreateFacilityType" className="mx-4">
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.FacilityPagesCreatenewFacilityType}
        </MDTypography>
        <MDButton
          onClick={() => onSubmit()}
          sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
          color="success"
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;{translations.FacilityPagesCreatenewFacilityTypeAddNewFacilityType}
        </MDButton>
      </MDBox>
      <form id="CreateFacilityTypeForm">
        <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
          <MDBox p={3}>
            <MDBox
              borderRadius="lg"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <MDInput
                className="test"
                onChange={(e) => setTypeName(e.target.value)}
                label={translations.EmployeeTypetableTypename}
                fullWidth
              ></MDInput>
              <MDInput
                className="test"
                onChange={(e) => setDescription(e.target.value)}
                label={translations.contactssearchDescription}
                fullWidth
              ></MDInput>
              <MDInput
                className="test"
                onChange={(e) => setCategory(e.target.value)}
                label={translations.FacilityPagesCreatenewFacilityTypeCategory}
                fullWidth
              ></MDInput>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDTypography variant="overline" color={"success"}>
                {SuccessText}
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDTypography variant="overline" color={"error"}>
                {ErrorText}
              </MDTypography>
            </MDBox>
          </MDBox>
        </div>
      </form>
    </Card>
  );
};

export default CreateFacilityTypes;
